/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { bool, object } from 'prop-types';
import { compose } from 'redux';

import { gql } from '@apollo/client';
import { Query } from '@apollo/client/react/components';
import { connect } from 'react-redux';

import CheckoutBannerContent from './CheckoutBannerContent';
import { GRAPHQL_ENV } from '../../../../../../gql';
import { getBrand } from '../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';

const CheckoutBanner = ({ brand, isUniversal }) => {
    const CHECKOUT_BANNER_QUERY = gql`
        query CheckoutBannerQuery {
            findContent(brand: "${brand['domain-name']}", environment: "${GRAPHQL_ENV}", contentType: "checkout_banner", locale: "en-us") {
                content
            }
        }`;

    return (
        <Query query={CHECKOUT_BANNER_QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return null;
                }
                if (error) {
                    return null;
                }
                if (data) {
                    return <CheckoutBannerContent data={data} isUniversal={isUniversal} />;
                }
                return null;
            }}

        </Query>
    );
};

CheckoutBanner.propTypes = {
    brand: object.isRequired,
    isUniversal: bool,
};

CheckoutBanner.defaultProps = {
    isUniversal: false,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

export default compose(
    connect(mapStateToProps),
)(CheckoutBanner);
